// The Shortlist's count in the box office tray (inc/box-office-subnav.php),
// styled like the cart's. The widget sends shortlist:updated with the active
// list's shows whenever it changes, pending adds and removes included.

document.addEventListener("shortlist:updated", (event) => {
  const slugs = (event as CustomEvent<{ slugs?: string[] }>).detail?.slugs ?? [];
  document.querySelectorAll<HTMLElement>(".js-shortlist-count").forEach((count) => {
    const number = count.querySelector(".js-shortlist-count-number");
    if (number) number.textContent = String(slugs.length);
    count.hidden = slugs.length === 0;
  });
});
